var _path, _path2, _path3, _g, _g2, _g3, _path4, _g4, _path5, _g5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNodejs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Nodejs"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 2"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.4568 80.5703C49.1177 80.5703 48.8013 80.4798 48.5074 80.3216L45.5011 78.5359C45.049 78.2873 45.2751 78.1968 45.4107 78.1516C46.021 77.9482 46.134 77.903 46.7669 77.5413C46.8347 77.4961 46.9251 77.5187 46.993 77.5639L49.2986 78.9428C49.389 78.988 49.502 78.988 49.5698 78.9428L58.5888 73.7212C58.6792 73.676 58.7244 73.5856 58.7244 73.4726V63.0522C58.7244 62.9391 58.6792 62.8487 58.5888 62.8035L49.5698 57.6046C49.4794 57.5594 49.3664 57.5594 49.2986 57.6046L40.2796 62.8035C40.1892 62.8487 40.1439 62.9618 40.1439 63.0522V73.4726C40.1439 73.563 40.1892 73.676 40.2796 73.7212L42.7434 75.1453C44.077 75.8234 44.9134 75.0323 44.9134 74.2411V63.9563C44.9134 63.8207 45.0264 63.6851 45.1846 63.6851H46.3374C46.4731 63.6851 46.6087 63.7981 46.6087 63.9563V74.2411C46.6087 76.0269 45.6367 77.0666 43.9414 77.0666C43.4215 77.0666 43.0147 77.0666 41.8618 76.5015L39.4884 75.1453C38.9007 74.8062 38.5391 74.1733 38.5391 73.4952V63.0748C38.5391 62.3967 38.9007 61.7637 39.4884 61.4247L48.5074 56.2032C49.0725 55.8867 49.8411 55.8867 50.4062 56.2032L59.4251 61.4247C60.0128 61.7637 60.3745 62.3967 60.3745 63.0748V73.4952C60.3745 74.1733 60.0128 74.8062 59.4251 75.1453L50.4062 80.3668C50.1123 80.5024 49.7732 80.5703 49.4568 80.5703ZM52.2371 73.4048C48.2814 73.4048 47.4676 71.5965 47.4676 70.0594C47.4676 69.9238 47.5807 69.7882 47.7389 69.7882H48.9143C49.0499 69.7882 49.1629 69.8786 49.1629 70.0142C49.3438 71.2122 49.8637 71.7999 52.2597 71.7999C54.1584 71.7999 54.9722 71.3704 54.9722 70.3533C54.9722 69.7656 54.7461 69.3361 51.785 69.0422C49.3212 68.7936 47.7841 68.2511 47.7841 66.2845C47.7841 64.4536 49.3212 63.3686 51.898 63.3686C54.7913 63.3686 56.2154 64.3632 56.3962 66.5332C56.3962 66.601 56.3736 66.6688 56.3284 66.7366C56.2832 66.7818 56.2154 66.827 56.1476 66.827H54.9722C54.8591 66.827 54.7461 66.7366 54.7235 66.6236C54.4523 65.3804 53.7515 64.9735 51.898 64.9735C49.8185 64.9735 49.5698 65.6968 49.5698 66.2393C49.5698 66.8948 49.8637 67.0983 52.6666 67.4599C55.4468 67.8216 56.7579 68.3415 56.7579 70.2854C56.7353 72.2746 55.1078 73.4048 52.2371 73.4048Z",
    fill: "#539E43"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 1"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Shape_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.4738 39.8147C21.4738 39.4078 21.2477 39.0235 20.8861 38.8201L11.302 33.3047C11.1438 33.2143 10.9629 33.1691 10.7821 33.1465H10.6917C10.5109 33.1465 10.33 33.2143 10.1718 33.3047L0.587704 38.8201C0.22604 39.0235 0 39.4078 0 39.8147L0.022604 54.6429C0.022604 54.8463 0.135624 55.0497 0.316456 55.1402C0.497288 55.2532 0.723327 55.2532 0.881555 55.1402L6.57776 51.8852C6.93942 51.6818 7.16546 51.2975 7.16546 50.8906V43.9512C7.16546 43.5443 7.3915 43.16 7.75317 42.9566L10.1718 41.5552C10.3526 41.4421 10.5561 41.3969 10.7595 41.3969C10.9629 41.3969 11.1664 41.4421 11.3246 41.5552L13.7432 42.9566C14.1049 43.16 14.3309 43.5443 14.3309 43.9512V50.8906C14.3309 51.2975 14.557 51.6818 14.9186 51.8852L20.6148 55.1402C20.7957 55.2532 21.0217 55.2532 21.2025 55.1402C21.3834 55.0497 21.4964 54.8463 21.4964 54.6429L21.4738 39.8147Z",
    fill: "#333333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Shape_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.5414 19.4037C67.3606 19.3133 67.1346 19.3133 66.9763 19.4037C66.7955 19.5168 66.6825 19.6976 66.6825 19.901V34.5936C66.6825 34.7292 66.6147 34.8649 66.4791 34.9553C66.3434 35.0231 66.2078 35.0231 66.0722 34.9553L63.6762 33.5764C63.3145 33.373 62.885 33.373 62.5234 33.5764L52.9393 39.1144C52.5776 39.3179 52.3516 39.7021 52.3516 40.109V51.1623C52.3516 51.5692 52.5776 51.9535 52.9393 52.1569L62.5234 57.6949C62.885 57.8983 63.3145 57.8983 63.6762 57.6949L73.2603 52.1569C73.6219 51.9535 73.848 51.5692 73.848 51.1623V23.6081C73.848 23.1786 73.6219 22.7943 73.2603 22.5909L67.5414 19.4037ZM66.6598 47.5231C66.6598 47.6361 66.6146 47.7265 66.5242 47.7717L63.2466 49.6705C63.1562 49.7157 63.0432 49.7157 62.9528 49.6705L59.6752 47.7717C59.5848 47.7265 59.5396 47.6135 59.5396 47.5231V43.7256C59.5396 43.6126 59.5848 43.5222 59.6752 43.477L62.9528 41.5783C63.0432 41.533 63.1562 41.533 63.2466 41.5783L66.5242 43.477C66.6146 43.5222 66.6598 43.6352 66.6598 43.7256V47.5231Z",
    fill: "#333333"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.4346 43.6351C99.7963 43.4316 99.9997 43.0474 99.9997 42.6405V39.9506C99.9997 39.5437 99.7737 39.1595 99.4346 38.956L89.9183 33.4407C89.5567 33.2372 89.1272 33.2372 88.7655 33.4407L79.1815 38.9786C78.8198 39.1821 78.5938 39.5663 78.5938 39.9732V51.0266C78.5938 51.4334 78.8198 51.8177 79.1815 52.0211L88.6977 57.4461C89.0594 57.6495 89.4889 57.6495 89.8279 57.4461L95.5919 54.2363C95.7728 54.1459 95.8858 53.9425 95.8858 53.739C95.8858 53.5356 95.7728 53.3322 95.5919 53.2418L85.9626 47.7038C85.7818 47.5908 85.6688 47.4099 85.6688 47.2065V43.7481C85.6688 43.5446 85.7818 43.3412 85.9626 43.2508L88.969 41.5329C89.1498 41.4199 89.3758 41.4199 89.5567 41.5329L92.563 43.2508C92.7438 43.3638 92.8569 43.5446 92.8569 43.7481V46.4606C92.8569 46.664 92.9699 46.8674 93.1507 46.9578C93.3315 47.0709 93.5576 47.0709 93.7384 46.9578L99.4346 43.6351Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.1959 43.115C89.2637 43.0698 89.3541 43.0698 89.4219 43.115L91.2529 44.1773C91.3207 44.2226 91.3659 44.2904 91.3659 44.3808V46.5056C91.3659 46.596 91.3207 46.6638 91.2529 46.709L89.4219 47.7714C89.3541 47.8166 89.2637 47.8166 89.1959 47.7714L87.365 46.709C87.2972 46.6638 87.252 46.596 87.252 46.5056V44.3808C87.252 44.2904 87.2972 44.2226 87.365 44.1773L89.1959 43.115Z",
    fill: "#539E43"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "mask-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.4998 33.4856C37.1381 33.2821 36.7087 33.2821 36.347 33.4856L26.8307 38.9784C26.4691 39.1818 26.2656 39.5661 26.2656 39.9729V50.9811C26.2656 51.3879 26.4917 51.7722 26.8307 51.9756L36.347 57.4684C36.7087 57.6718 37.1381 57.6718 37.4998 57.4684L47.0161 51.9756C47.3777 51.7722 47.5812 51.3879 47.5812 50.9811V39.9729C47.5812 39.5661 47.3551 39.1818 47.0161 38.9784L37.4998 33.4856Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "path-2-link"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-2_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.4998 33.4856C37.1381 33.2821 36.7087 33.2821 36.347 33.4856L26.8307 38.9784C26.4691 39.1818 26.2656 39.5661 26.2656 39.9729V50.9811C26.2656 51.3879 26.4917 51.7722 26.8307 51.9756L36.347 57.4684C36.7087 57.6718 37.1381 57.6718 37.4998 57.4684L47.0161 51.9756C47.3777 51.7722 47.5812 51.3879 47.5812 50.9811V39.9729C47.5812 39.5661 47.3551 39.1818 47.0161 38.9784L37.4998 33.4856Z",
    fill: "url(#paint0_linear_170_3057)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_170_3057",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 26,
    y: 33,
    width: 22,
    height: 25
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "path-2_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.4998 33.4856C37.1381 33.2821 36.7087 33.2821 36.347 33.4856L26.8307 38.9784C26.4691 39.1818 26.2656 39.5661 26.2656 39.9729V50.9811C26.2656 51.3879 26.4917 51.7722 26.8307 51.9756L36.347 57.4684C36.7087 57.6718 37.1381 57.6718 37.4998 57.4684L47.0161 51.9756C47.3777 51.7722 47.5812 51.3879 47.5812 50.9811V39.9729C47.5812 39.5661 47.3551 39.1818 47.0161 38.9784L37.4998 33.4856Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_170_3057)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.0384 38.9788L37.4769 33.4861C37.3865 33.4409 37.2735 33.3957 37.183 33.373L26.4688 51.7275C26.5592 51.8405 26.6722 51.9309 26.7852 51.9987L36.3467 57.4915C36.6179 57.6497 36.9344 57.6949 37.2282 57.6045L47.287 39.2049C47.2192 39.1145 47.1288 39.0466 47.0384 38.9788Z",
    fill: "url(#paint1_linear_170_3057)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clipped_2"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_170_3057",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 26,
    y: 33,
    width: 22,
    height: 25
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "path-2_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.4998 33.4856C37.1381 33.2821 36.7087 33.2821 36.347 33.4856L26.8307 38.9784C26.4691 39.1818 26.2656 39.5661 26.2656 39.9729V50.9811C26.2656 51.3879 26.4917 51.7722 26.8307 51.9756L36.347 57.4684C36.7087 57.6718 37.1381 57.6718 37.4998 57.4684L47.0161 51.9756C47.3777 51.7722 47.5812 51.3879 47.5812 50.9811V39.9729C47.5812 39.5661 47.3551 39.1818 47.0161 38.9784L37.4998 33.4856Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_170_3057)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape_7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.0606 51.9754C47.3319 51.8171 47.5353 51.5459 47.6257 51.252L37.1375 33.3497C36.8662 33.3045 36.5724 33.3271 36.3238 33.4853L26.8301 38.9555L37.0697 57.6263C37.2053 57.6037 37.3635 57.5585 37.4992 57.4907L47.0606 51.9754Z",
    fill: "url(#paint2_linear_170_3057)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_8",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.0621 51.9754L37.5232 57.4682C37.3876 57.536 37.252 57.5812 37.0938 57.6038L37.2746 57.9429L47.8532 51.8172V51.6816L47.582 51.2295C47.5368 51.5459 47.3334 51.8172 47.0621 51.9754Z",
    fill: "url(#paint3_linear_170_3057)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_9",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.0621 51.9754L37.5232 57.4682C37.3876 57.536 37.252 57.5812 37.0938 57.6038L37.2746 57.9429L47.8532 51.8172V51.6816L47.582 51.2295C47.5368 51.5459 47.3334 51.8172 47.0621 51.9754Z",
    fill: "url(#paint4_linear_170_3057)"
  })))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_170_3057",
    x1: 34.868,
    y1: 34.4928,
    x2: 24.7384,
    y2: 46.7514,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3288,
    stopColor: "#418B3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6352,
    stopColor: "#419637"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9319,
    stopColor: "#3FA92D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3FAE2A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_170_3057",
    x1: 41.102,
    y1: 60.5117,
    x2: 66.4407,
    y2: 50.3889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1376,
    stopColor: "#41873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4032,
    stopColor: "#54A044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7136,
    stopColor: "#66B848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9081,
    stopColor: "#6CC04A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_170_3057",
    x1: 25.9174,
    y1: 58.341,
    x2: 47.9375,
    y2: 58.341,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0919165,
    stopColor: "#6CC04A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2864,
    stopColor: "#66B848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5968,
    stopColor: "#54A044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8624,
    stopColor: "#41873F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_170_3057",
    x1: 25.9189,
    y1: 61.4744,
    x2: 47.939,
    y2: 61.4744,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0919165,
    stopColor: "#6CC04A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2864,
    stopColor: "#66B848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5968,
    stopColor: "#54A044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8624,
    stopColor: "#41873F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_170_3057",
    x1: 23.6494,
    y1: 35.4102,
    x2: 21.5733,
    y2: 63.3532,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3288,
    stopColor: "#418B3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6352,
    stopColor: "#419637"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9319,
    stopColor: "#3FA92D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3FAE2A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNodejs);
export default __webpack_public_path__ + "static/media/Nodejs.0c4668bd0864a964bfaec50d72091d10.svg";
export { ForwardRef as ReactComponent };